import { render, staticRenderFns } from "./imprint-de.vue?vue&type=template&id=053ac623&scoped=true"
import script from "./imprint-de.vue?vue&type=script&lang=js"
export * from "./imprint-de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ac623",
  null
  
)

export default component.exports